import styled, { css } from 'styled-components'
import { Modal } from 'antd'
import { blue, redPrimary } from '../../../../color'

export const RejectModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-modal-header {
    padding: 16px 20px 12px;
    border-bottom: none;
  }

  .ant-modal-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f1f1f;
  }

  .ant-modal-body {
    padding: 4px 20px 8px;
  }

  .ant-modal-footer {
    padding: 12px 20px 16px;
    border-top: 1px solid #f0f0f0;
  }

  .ant-modal-close-x {
    width: 48px;
    height: 48px;
    line-height: 48px;
  }
`

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const HeaderIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${props => (props.$danger ? '#fff1f0' : '#fff7e6')};
  color: ${props => (props.$danger ? redPrimary : '#d46b08')};
  font-size: 16px;
`

export const CounterHint = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.4;
  background: ${props => (props.$danger ? '#fff1f0' : '#f5f5f5')};
  color: ${props => (props.$danger ? '#a8071a' : '#595959')};
  border: 1px solid ${props => (props.$danger ? '#ffccc7' : 'transparent')};
`

export const SectionLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 8px;
`

export const StepOptions = styled.div`
  display: grid;
  grid-template-columns: ${props =>
    props.$single ? '1fr' : '1fr 1fr'};
  gap: 8px;
  margin-bottom: 16px;
`

export const StepOption = styled.button`
  appearance: none;
  border: 1px solid #e8e8e8;
  background: #fff;
  border-radius: 8px;
  padding: 10px 12px;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    background 0.15s ease;
  outline: none;

  &:hover {
    border-color: ${blue};
  }

  ${props =>
    props.$active &&
    css`
      border-color: ${blue};
      background: #f0f5ff;
      box-shadow: 0 0 0 1px ${blue};
    `}

  ${props =>
    props.$disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    `}
`

export const StepOptionTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 2px;
`

export const StepOptionDesc = styled.div`
  font-size: 11px;
  color: #8c8c8c;
`

export const ReasonField = styled.div`
  .ant-input {
    border-radius: 8px;
    resize: none;
    font-size: 13px;
    padding: 10px 12px;

    &:focus,
    &:hover {
      border-color: ${blue};
    }
  }

  .ant-form-item-explain {
    font-size: 12px;
  }
`

export const CharCount = styled.div`
  text-align: right;
  font-size: 11px;
  color: #bfbfbf;
  margin-top: 4px;
`
